
import { schema } from "./types";
import { IAutomationAppComponent, IAutomationObject } from "../../../types";
import { OverviewPanel } from './OverviewPanel'
import { OperatorPanel } from './'
import { Icon } from "./Icon";
import { schema as schemaBuilding } from '../../../Plants/Buildings/P_Building'


export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: Icon,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    createConfig: {
        group: 'Spaces',
        name: "Graz",
        description: "Campus",
        panel: OverviewPanel,
        defaultState: {  },
        defaultProperties: [
        ]
    },
    addAppFilter: (app: IAutomationObject) => app.schema === schemaBuilding
}